/**
 * API client for API key management endpoints.
 * Routes: /api/mgmt/projects/:projectId/keys
 */

import { apiFetch } from './client';

export interface ApiKey {
  keyId: string;
  projectId: string;
  keyPrefix: string;
  description: string;
  enabled: boolean;
  expiresAt?: string;
  createdAt: string;
  lastUsedAt?: string;
}

export interface CreateKeyResponse {
  key: ApiKey;
  /** The full API key value, shown only once at creation time. */
  rawKey: string;
}

export async function listKeys(projectId: string, token: string): Promise<ApiKey[]> {
  const data = await apiFetch<{ keys: ApiKey[] }>(
    `/api/mgmt/projects/${encodeURIComponent(projectId)}/keys`,
    token,
  );
  return Array.isArray(data) ? data : (data.keys ?? []);
}

export async function createKey(
  projectId: string,
  description: string,
  token: string,
): Promise<CreateKeyResponse> {
  return apiFetch<CreateKeyResponse>(
    `/api/mgmt/projects/${encodeURIComponent(projectId)}/keys`,
    token,
    {
      method: 'POST',
      body: JSON.stringify({ description }),
    },
  );
}

export async function revokeKey(
  projectId: string,
  keyId: string,
  token: string,
): Promise<void> {
  return apiFetch<void>(
    `/api/mgmt/projects/${encodeURIComponent(projectId)}/keys/${encodeURIComponent(keyId)}`,
    token,
    {
      method: 'DELETE',
    },
  );
}
